import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-days-range-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './days-range-dialog.html',
  styleUrl: './days-range-dialog.css'
})
export class DaysRangeDialog {
  @Output() closed = new EventEmitter<void>();
  @Output() submit = new EventEmitter<{ days: number; includeNotifications?: boolean; includeViolations?: boolean }>();

  @Input() min: number = 1;
  @Input() max?: number; // undefined means no upper bound
  @Input() showIncludeNotifications: boolean = false;
  @Input() showIncludeViolations: boolean = false;

  daysInput: number | string | null = 7;
  error: string | null = null;
  includeNotifications: boolean = false;
  includeViolations: boolean = false;

  constructor(private readonly i18n: TranslateService) {}

  onCancel(): void {
    this.closed.emit();
  }

  onSubmit(): void {
    const raw = this.daysInput;
    if (raw === null || raw === '') {
      this.error = this.getErrorMessage();
      return;
    }
    const asNumber = typeof raw === 'number' ? raw : Number(String(raw).trim());
    const isInteger = Number.isInteger(asNumber);
    const exceedsMax = this.max !== undefined && asNumber > this.max;
    if (!Number.isFinite(asNumber) || !isInteger || asNumber < this.min || exceedsMax) {
      this.error = this.getErrorMessage();
      return;
    }
    this.error = null;
    this.submit.emit({
      days: asNumber,
      includeNotifications: this.includeNotifications,
      includeViolations: this.includeViolations
    });
  }

  private getErrorMessage(): string {
    if (this.max !== undefined) {
      return this.i18n.instant('metrics_days_dialog.error_min_max', { min: this.min, max: this.max });
    }
    return this.i18n.instant('metrics_days_dialog.error_min', { min: this.min });
  }
}


